
import './main.css'

import { useEffect, useState } from 'react';
import { RightOutlined, VideoCameraOutlined, ExclamationCircleOutlined, SettingOutlined, CrownOutlined, MessageOutlined, FireOutlined, CommentOutlined, LinkOutlined, YoutubeOutlined } from '@ant-design/icons';
import { jwtDecode } from "jwt-decode";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Radio, Button, Modal, Input, Space, message, Carousel, Tabs, Collapse, Tooltip } from 'antd';
import logo from '../../images/logo.png'
import callAPI from '../fetch/main';
import ShowPlans from "../../comps/show_plans/main";



function Sider(props) {
  const { TextArea } = Input;
  const [open, setOpen] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const [feedbacktext, setFeedbackText] = useState('')

  const [showReconnect, setShowReconnect] = useState()

  const [showSettings, setShowSettings] = useState()

  const [settingsPayload, setSettingsPayload] = useState()
  const [loading, setLoading] = useState()

  const [initialSettingPayload, setInitalSettingPayload] = useState()
  const [settingsApiUpdate, setSettingsApiUpdated] = useState()
  const [updateLoading, setupdateLoading] = useState()

  const token = localStorage.getItem("token")

  const location = useLocation();

  const [showPlanModal, setShowPlanModal] = useState(props?.showPlan || false)

  const [decodedToken, setDecodeToken] = useState()
  

  const yt_vids = [
    {
      key: '1',
      label: 'English',

      children: <iframe style={{ display: 'flex', margin: 'auto' }} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/fGweVnU99x0?si=8m1cTZ2zMiYsUDUt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    },
    // {
    //   key: '2',
    //   label: 'தமிழ்',
    //   children: <iframe style={{ display:'flex', margin:'auto'}} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/9CL7q4lB8BI?si=qku55Z__aqG98cqP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    // },
    // {
    //     key: '3',
    //     label: 'తెలుగు',
    //     children: <iframe style={{ display:'flex', margin:'auto'}} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/9CL7q4lB8BI?si=qku55Z__aqG98cqP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    // },
    {
      key: '4',
      label: 'हिंदी',
      children: <iframe style={{ display: 'flex', margin: 'auto' }} width={'90%'} height={'500px'} src="https://www.youtube.com/embed/v2Zy8hgyaps?si=HNOuC6J-sgNoIX38" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    },
  ];


  useEffect(() => {

    if(props?.showPlan == undefined){
      return
    }
    setShowPlanModal(props?.showPlan)

  },[props?.showPlan])

  // Settings started

  useEffect(() => {
    if (settingsApiUpdate?.code == 200) {
      setShowSettings(false)
      message.success("Settings Updated")
    }
    if (settingsApiUpdate?.code != undefined && settingsApiUpdate?.code != 200) {
      message.error("Settings not updated")
    }

  }, [settingsApiUpdate])

  useEffect(() => {
    if (settingsPayload?.data != undefined) {

      // {"automation_setting": {"dm_automation": "true", "account_automation": "true", "comment_automation": "true"}}
      
      setInitalSettingPayload(settingsPayload?.data)
      setSettingsPayload(settingsPayload?.data)
    }

  }, [settingsPayload])

  useEffect(() => {
    let apiURL = '/account-setting'
    callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setSettingsPayload })
  },[])
  useEffect(() => {
    try {
      window.createLemonSqueezy()
    }
    catch (e) {

    }

  }, [])

  useEffect(() => {
    new Promise((resolve, reject) => {
      if (window.Razorpay) {
        return resolve(true);
      }

      const script = document.createElement('script');
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);  // Resolve once the script is loaded
      script.onerror = (err) => reject(new Error("Razorpay script failed to load"));

      document.body.appendChild(script);
    });
  })


  const updateSettingsAPI = () => {
    let apiURL = `/account-setting`
    callAPI({ url: apiURL, method: "PUT", body: settingsPayload, loadingState: setupdateLoading, dataState: setSettingsApiUpdated })

  }

  const updateAutomationData = (key, value) => {


    if (key == "account_automation") {
      setSettingsPayload({
        ...settingsPayload,
        automation_setting: {
          ...settingsPayload.automation_setting,
          account_automation: value,
          dm_automation: value,
          comment_automation: value
        },
      });
      return
    }
    setSettingsPayload({
      ...settingsPayload,
      automation_setting: {
        ...settingsPayload.automation_setting,
        [key]: value,
      },
    });
  };

  // Settings ended


  function Avatar({ src, name }) {
    const [error, setError] = useState(false);

    return (
      <div>
        {error ? (
          <div className="avatar">{name != undefined ? name[0] : "C"}</div>
        ) : (
          <img src={src} onError={() => setError(true)} />
        )}
      </div>
    );
  }

  const [paymentLinkLoading, setPaymentLinkLoading] = useState()
  const [paymentLinkData, setPaymentLinkData] = useState({})

  let user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  const [showINR, setShowINR] = useState((user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta") ? true : false)


  useEffect(() => {
    let jwt_token = jwtDecode(token)

    setDecodeToken(jwt_token?.default_page?.connected_instagram_account || jwt_token["default_page"])
  }, [])

  useEffect(() => {


    if (paymentLinkData?.payment_url == undefined) {
      return
    }

    messageApi.destroy("payment-process")


    if (!showINR && window.LemonSqueezy) {
      const checkoutUrl = paymentLinkData.payment_url
      window.LemonSqueezy.Url.Open(checkoutUrl);
    }

    if (showINR && window.Razorpay) {

      try {

        const options = {
          key: "rzp_live_JtjGCHjkESNzIZ", // Replace with your Razorpay key
          name: "InstantDM",
          description: "Affordable Comment to DM automation tool",
          subscription_id: paymentLinkData.rzpy_sub_id, // Order ID from your server (generated by your backend)
          handler: function (response) {
            setShowPlanModal(false)
            message.success("Payment completed, Please wait while we're verfiying!")
            setPaymentLinkData({})
            // setShowWaitingPaymentUpdate(true)
            // alert("Payment Successful: " + response.razorpay_payment_id);
          },
          error: function (response) {
            // setShowPlanModal(false)
            message.error("Payment Failed, Please try again later!")
            setPaymentLinkData({})
            // setShowWaitingPaymentFailed(true)
            // alert("Payment Failed: " + response.error.description);
          },
          modal: {
            ondismiss: function () {
              message.error("Payment Cancelled, Please try again!")
              setPaymentLinkData({})
            }
          },
          prefill: {
            email: paymentLinkData.customer_email,
          },
          "notes": paymentLinkData.notes != undefined ? { ...paymentLinkData.notes } : {},
          theme: {
            color: "#1677ff",
          },
        };

        const razorpayInstance = new window.Razorpay(options);
        razorpayInstance.open();

      } catch (error) {
        alert("Error loading Razorpay: " + error.message);
      } finally {
        // setLoading(false);
      }

    }

    else {
      message.error("Please try again later...")
    }



  }, [paymentLinkData])

  const handleLogout = () => {
    // Clear all localStorage
    Object.keys(localStorage).forEach((key) => {
      if (key !== "previous_config") {
          localStorage.removeItem(key);
      }
  });
    // Redirect to the login page
    window.location.href = '/login';
  };

  return (

    <div>
      {contextHolder}
      <div className='mobile-nav'>
        <div style={{ flex: 1 }}>
          <Link to='/'>
          <img src={logo} style={{ height: '40px' }} />
          </Link>
        </div>

        <div onClick={() => { setShowPlanModal(true) }} className='feedback' style={{ marginLeft: '10px' }}>
          <h6 style={{ fontSize: '16px', color: 'black', padding: '10px' }}><CrownOutlined /></h6>
        </div>
        {/* <div onClick={() => { createPaymentLink("topup",messageApi, setPaymentLinkLoading, setPaymentLinkData) }} className='feedback' style={{ marginLeft: '0px' }}>
          <h6 style={{ fontSize: '16px', color: 'black', padding: '10px' }}><FireOutlined /></h6>
        </div> */}

        {/* <p>@{decodedToken?.username}</p> */}
        <div onClick={() => { setShowVideo(true) }} className='feedback' style={{ marginLeft: '0px' }}>
          <h6 style={{ fontSize: '16px', color: 'black', padding: '10px' }}><VideoCameraOutlined /></h6>
        </div>
        <div onClick={() => { setShowReconnect(true) }} className='feedback' style={{ marginLeft: '0px', marginRight: '0px' }}>
          <h6 style={{ fontSize: '16px', color: 'red', padding: '10px' }}><ExclamationCircleOutlined /></h6>
        </div>
        <div onClick={() => { setShowSettings(true) }} className='feedback' style={{ marginLeft: '0px', marginRight: '20px' }}>
          <h6 style={{ fontSize: '16px', padding: '10px' }}><SettingOutlined /></h6>
        </div>
        
        {
          ["/" , "/oia","/yt"].includes(location.pathname ) && <div className='float-menu-mob mobile'>
          <Link to='/' className={location.pathname === '/' ? 'active' : ''}><CommentOutlined />DM</Link>
          <Link to='/oia' className={location.pathname === '/oia' ? 'active' : ''} ><LinkOutlined />OIA</Link>
          <Link to='/yt' className={location.pathname === '/yt' ? 'active' : ''} ><YoutubeOutlined />YT</Link>
        </div>
        }
        

      </div>

      <div className="sidebar">

        <div>
          <div className='links'>

            <Link to='/'>
              <img src={logo} style={{ height: '72px' }} />
            </Link>
            <div className='insta-card insta-card-side'>
              <Avatar src={`https://imagecorsworkers.sanjayhotaction.workers.dev/${decodedToken?.profile_picture_url}`} name={decodedToken?.name} />
              <div>
                <h3>{decodedToken?.name || "Connect IG"}</h3>
                <p>@{decodedToken?.username || "to automate."}</p>
              </div>
            </div>

          </div>
          <div className='menu-options'>


          <div className='float-menu'>
                <Link to='/' className={location.pathname === '/' ? 'active' : ''}><CommentOutlined />DM</Link>
                <Link to='/oia' className={location.pathname === '/oia' ? 'active' : ''} ><LinkOutlined />OIA</Link>
                <Link to='/yt' className={location.pathname === '/YT' ? 'active' : ''} ><YoutubeOutlined />YT</Link>
          </div>
        {/* <div className='products-nav'>
          <p>Products</p>
          <div onClick={() => { setShowReconnect(true) }} >
              <h6 > <CommentOutlined className='mo-icon' />Instagram Automation</h6>
            </div>
            <div onClick={() => { setShowReconnect(true) }} >
              <h6 > <LinkOutlined className='mo-icon' />Open In App</h6>
            </div>
          </div> */}

            <div onClick={() => { setShowPlanModal(true) }}>
              <h6> <CrownOutlined className='mo-icon' />My Plan</h6>
            </div>
            {/* <div onClick={() => { 
            createPaymentLink("topup",messageApi, setPaymentLinkLoading, setPaymentLinkData)
          }}>

        
          <h6> <FireOutlined  className='mo-icon'/>Buy Credits</h6>
        </div> */}

            


            <div onClick={() => { setShowReconnect(true) }} >
              <h6 > <ExclamationCircleOutlined className='mo-icon' />Automation Not working?</h6>
            </div>
            <div onClick={() => { setShowVideo(true) }} >
              <h6 ><VideoCameraOutlined className='mo-icon' />How to use platform</h6>
            </div>
            <div onClick={() => { setShowSettings(true) }} >
              <h6 ><SettingOutlined className='mo-icon' />Account Settings</h6>
            </div>
            <div onClick={() => { setOpen(true) }}>
              <h6> <MessageOutlined className='mo-icon' /> Have feedback?</h6>
            </div>

          </div>

         

        </div>

        {/* <div> */}
        {/* <div className='menu-grid'>
        <div className='video'><VideoCameraOutlined/></div>
        <div className='settings'><SettingOutlined/></div>
        <div className='plan'><CrownOutlined/></div>
        <div className='error'><ExclamationCircleOutlined/></div>
      </div> */}


        {/* </div> */}
        


        <Modal
          title="Product Guide"
          open={showVideo}
          width={800}
          height={600}
          onOk={() => {
            setShowVideo(false)
          }}

          onCancel={() => { setShowVideo(false) }}
        >
          <Tabs defaultActiveKey="1" items={yt_vids} />

        </Modal>

        <Modal
          title="Submit your Feedback"
          open={open}
          onOk={() => {


            setOpen(false)

            // messageApi.open({
            //     key:"1",
            //     type: 'success',
            //     content: 'Thanks for the feedback!',
            //   });
          }}
          // okText = "Submit my feedback"
          confirmLoading={confirmLoading}
          onCancel={() => { setOpen(false) }}
        >
          <p>Hii There, thanks for taking a moment to share feedback. It will really help us to improve our service and product a lot.</p>
          <a target='_blank' href='https://www.instagram.com/code_with_ssk'>Send a DM in instagram - Code with SSK</a>
          <p>or you can send email to <span style={{ color: 'blue' }}>ssk@instantdm.com</span></p>
          {/* <TextArea value={feedbacktext} onChange={(e) => setFeedbackText(e.target.value)} rows={8} placeholder="Please share your feedback here." /> */}

        </Modal>

        <Modal
          title="Automation not working?"
          open={showReconnect}
          confirmLoading={confirmLoading}
          onCancel={() => { setShowReconnect(false) }}
        >

            <div style={{display:'flex' , flexDirection:'column', marginTop:'20px', gap:'20px', marginBottom:'20px'}}>
              <h3>Please Select your issue</h3>
            <Button danger><a href="/ig-connect">Reels, Posts Comment DM not working?</a></Button>
            <Button danger><a href="/ig-connect?show_ig_connect=true">Story DM not working?</a></Button>
            <Button danger><a href="/ig-connect?show_ig_connect=true">Followers only DM not working?</a></Button>
            </div>
          {/* <div style={{ marginBottom: '20px', display: "flex", flexDirection: "row", alignContent: 'flex-start', alignItems: 'center', justifyContent: "space-between" }}>
            Regular post comment automation not working
            <Button type="primary" danger><a href="/ig-connect">Reconnect Instagram via FB</a></Button>
          </div>
          <div style={{ marginBottom: '20px', display: "flex", flexDirection: "row", alignContent: 'flex-start', alignItems: 'center', justifyContent: "space-between" }}>
            <p>Boosted post comment automation not working</p>
            <Button danger><a href="/ig-connect?show_ig_connect=true">Reconnect with Instagram</a></Button>
          </div> */}

          <Collapse items={[
            {
              key: '1',
              label: 'Not working after reconnected?',
              children: <p>Please reach out via instagram <a href='https://instagram.com/code_with_ssk' target='_blank'>@code_with_ssk</a> or mail us at ssk@instantdm.com</p>,
            },
          ]} />
        </Modal>

        <Modal
          title="Settings"
          open={showSettings}
          okText='Publish Changes'
          confirmLoading={updateLoading}
          onOk={() => { updateSettingsAPI() }}
          onCancel={() => { setSettingsPayload(initialSettingPayload); setShowSettings(false); }}
        >

          <h3 style={{ marginBottom: '0px', fontSize: '18px' }}>Account Automation settings</h3>
          <p style={{ marginTop: '0px', fontSize: '12px' }}>Configure your account level automation</p>

          {settingsPayload?.automation_setting != undefined &&
            <>
              <div className='setting-item'>
                <div className='row'>
                  <h3 >Global Automations</h3>
                  <Radio.Group onChange={(e) => updateAutomationData('account_automation', e.target.value)} defaultValue={settingsPayload.automation_setting.account_automation}>
                    <Radio.Button value="true">Enabled</Radio.Button>
                    <Radio.Button value="false">Disabled</Radio.Button>
                  </Radio.Group>
                </div>
                <p>Your account level automation, if you disabled it no automations will work.</p>
              </div>
              <div className='setting-item'>
                <div className='row'>
                  <h3>Comment Replies</h3>
                  <Tooltip title={settingsPayload.automation_setting.account_automation == "false" ? "Please enable account level automation" : ""}>
                    <Radio.Group onChange={(e) => updateAutomationData('comment_automation', e.target.value)} disabled={settingsPayload.automation_setting.account_automation == "false" ? true : false} value={settingsPayload.automation_setting.comment_automation}>
                      <Radio.Button value="true">Enabled</Radio.Button>
                      <Radio.Button value="false">Disabled</Radio.Button>
                    </Radio.Group>
                  </Tooltip>
                </div>
                <p>Your account level comment automation, if you disabled it no comment automations will work.</p>
              </div>
              <div className='setting-item'>
                <div className='row'>
                  <h3>DM Automations</h3>
                  <Tooltip title={settingsPayload.automation_setting.account_automation == "false" ? "Please enable account level automation" : ""}>
                    <Radio.Group onChange={(e) => updateAutomationData('dm_automation', e.target.value)} disabled={settingsPayload.automation_setting.account_automation == "false" ? true : false} value={settingsPayload.automation_setting.dm_automation}>
                      <Radio.Button value="true">Enabled</Radio.Button>
                      <Radio.Button value="false">Disabled</Radio.Button>
                    </Radio.Group>
                  </Tooltip>
                </div>
                <p>Your account level DM automation, if you disabled it no DM automations will work.</p>
              </div>
            </>}

            <Button danger onClick={handleLogout}>Logout</Button>
        </Modal>

        <Modal
          title="Plans"
          open={showPlanModal}
          onCancel={() => {setShowPlanModal(false); 
            if (props?.setShowPlan != undefined){
              props.setShowPlan(false)
            }}}
          footer={null}
          width='90%'
          style={{ maxWidth: '1200px' }}
        >


          <ShowPlans messageApi={messageApi} setPaymentLinkLoading={setPaymentLinkLoading} setPaymentLinkData={setPaymentLinkData} currentPlan={localStorage.getItem("planid")} />
        </Modal>

      </div>
    </div>)

}
export default Sider;